import React from "react";
import { useLocation, useParams } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { crmCreatePageContent } from "./CrmCreateContent";
import { gettingStartedCrm } from "./CrmGettingStartedContent";
import { managingCrmContent } from "./ManagingCrmContent";
import VideoContainer from "../../common/VideoContainer";
import ImageContainer from "../../common/ImageContainer";
// fetching my content based on url
const CONTENT_MAP = {
  "create-crm": crmCreatePageContent,
  "anydone-crm-ai-agent-platform": gettingStartedCrm,
  "managing-crm":managingCrmContent
};

const CrmPages = () => {
  const { pageType } = useParams();
  const { pathname } = useLocation();
  const section = pathname.split("/")[1];

  const contentSource = CONTENT_MAP[section] || {};
  const content = contentSource[pageType];
  if (!content) {
    return <div>Page not found</div>;
  }

    // Transform function to map <test-component> to Test component
    const transform = (node, index) => {
      if (node.type === "tag") {
        if (node.name === "video-component") {
          const { src, alt } = node.attribs || {};
          return <VideoContainer key={index} src={src} />;
        }
    
        if (node.name === "image-component") {
          const { src, alt } = node.attribs || {};
          return <ImageContainer key={index} src={src} alt={alt} />;
        }
      }
    };
  
  return (
    <div className="ai-agent-container">
      <h2 className="headingTwo">{content.title}</h2>
      <div>{ReactHtmlParser(content.content, { transform })}</div>
    </div>
  );
};

export default CrmPages;
